import  * as _ from "ramda";
import TermExpander from "./term-expander";
import {List} from "immutable";
import ParseReducer from "./parse-reducer.js";
import reducer, {MonoidalReducer} from "shift-reducer";
import {makeDeserializer} from "./serializer";
import Syntax from "./syntax";
import codegen, {FormattedCodeGen} from "shift-codegen";
import {VarBindingTransform, CompiletimeTransform} from "./transforms";
import Term, {isEOF, isBindingIdentifier, isFunctionDeclaration, isFunctionExpression, isFunctionTerm, isFunctionWithName, isSyntaxDeclaration, isVariableDeclaration, isVariableDeclarationStatement, isImport, isExport} from "./terms";
import Reader from "./shift-reader";
import {unwrap} from "./macro-context";
import {replaceTemplate} from "./template-processor";
let geval_309 = eval;
export function sanitizeReplacementValues(values_312) {
  if (Array.isArray(values_312)) {
    return sanitizeReplacementValues(List(values_312));
  } else if (List.isList(values_312)) {
    return values_312.map(sanitizeReplacementValues);
  } else if (values_312 == null) {
    throw new Error("replacement values for syntax template must not be null or undefined");
  } else if (typeof values_312.next === "function") {
    return sanitizeReplacementValues(List(values_312));
  }
  return unwrap(values_312);
}
function loadForCompiletime_310(expr_313, context_314) {
  let deserializer_315 = makeDeserializer(context_314.bindings);
  let sandbox_316 = {syntaxQuote: function (strings_323, ...values_322) {
    let ctx_324 = deserializer_315.read(_.last(values_322));
    let reader_325 = new Reader(strings_323, ctx_324.context, _.take(values_322.length - 1, values_322));
    return reader_325.read();
  }, syntaxTemplate: function (str_327, ...values_326) {
    return replaceTemplate(deserializer_315.read(str_327), sanitizeReplacementValues(values_326));
  }};
  let sandboxKeys_317 = List(Object.keys(sandbox_316));
  let sandboxVals_318 = sandboxKeys_317.map(k_328 => sandbox_316[k_328]).toArray();
  let parsed_319 = reducer(new ParseReducer, new Term("Module", {directives: List(), items: List.of(new Term("ExpressionStatement", {expression: new Term("FunctionExpression", {isGenerator: false, name: null, params: new Term("FormalParameters", {items: sandboxKeys_317.map(param_329 => {
    return new Term("BindingIdentifier", {name: Syntax.fromIdentifier(param_329)});
  }), rest: null}), body: new Term("FunctionBody", {directives: List.of(new Term("Directive", {rawValue: "use strict"})), statements: List.of(new Term("ReturnStatement", {expression: expr_313}))})})}))}));
  let gen_320 = codegen(parsed_319, new FormattedCodeGen);
  let result_321 = context_314.transform(gen_320, {babelrc: true, filename: context_314.filename});
  return geval_309(result_321.code).apply(undefined, sandboxVals_318);
}
const loadSyntax_311 = _.cond([[_.where({binding: isBindingIdentifier}), _.curry(({binding, init}, context_330, env_331) => {
  let termExpander_332 = new TermExpander(context_330);
  let initValue_333 = loadForCompiletime_310(termExpander_332.expand(init), context_330);
  env_331.set(binding.name.resolve(), new CompiletimeTransform(initValue_333));
})], [_.T, __334 => assert(false, "not implemented yet")]]);
export default loadSyntax_311;
